import React, { useRef, useState, useImperativeHandle, useEffect } from "react";
import styles from "./PictureUploadField.module.css";
import FileUploaderModal from "../FileUploaderModal/FileUploaderModal";
import i18n from "../../Services/i18n";
import { useModal } from "../../Context/ModalContext";
import FileFolderPreview from "../FileFolderPreview/FileFolderPreview";
import { useToasts } from "../../LayoutComponents/ToastContext";
import FileService from "../../Services/fileService";

const PictureUploadField = React.forwardRef((props, ref) => {
  const {
    initFileId,
    horseThumbnail,
    horseThumbnailfileId,
    clientThumbnail,
    clientThumbnailFileId,
    serviceThumbnail,
    serviceThumbnailFileId,
    image,
    label = i18n.t("PictureUploadField.LabelDefaultImage"),
    restrictedImageList = null,
  } = props;
  const fileUploadModal = useRef(null);
  const [selectedOption, setSelectedOption] = useState(image ? "Importer une image" : "Aucune image");
  const [displayedImage, setDisplayedImage] = useState(image);
  const { openModal } = useModal();
  const { addToast } = useToasts();
  const defaultImageFromMediaIdRef = useRef(null);

  const [fileId, setFileId] = useState(initFileId);
  const [localRestrictedImageList, setLocalRestrictedImageList] = useState();

  useEffect(() => {
    const getRestrcitedImageList = async () => {
      const r = await restrictedImageList();
      setLocalRestrictedImageList(r);
    };
    if (restrictedImageList) getRestrcitedImageList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setDisplayedImage(image || null);
    setSelectedOption(image ? "Importer une image" : "Aucune image");
    setFileId(initFileId);
  }, [image, initFileId]);

  useEffect(() => {
    if (selectedOption === "Image du service") {
      setDisplayedImage(serviceThumbnail);
      setFileId(serviceThumbnailFileId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.serviceThumbnailFileId]);

  useImperativeHandle(ref, () => ({
    getData: () => {
      console.log();
      return {
        thumbnail: displayedImage,
        fileId: fileId,
        isFromDefault:
          fileId &&
          fileId !== null &&
          (fileId === horseThumbnailfileId || fileId === clientThumbnailFileId || fileId === serviceThumbnailFileId),
      };
    },
  }));

  const handleDefaultImageButtonClick = async () => {
    if (!localRestrictedImageList) {
      fileUploadModal.current.open();
    } else {
      openModal({
        title: i18n.t("Generic.DefaultImageOptions.SelectFromMedias"),
        hideSaveButton: true,
        form: "formHorse",
        content: (
          <>
            {" "}
            <div style={{ margin: "0 10px" }}>
              <p>{i18n.t("Generic.DefaultImageOptions.MustSelectFromMedias")}</p>
            </div>
            <FileFolderPreview
              refresh={() => {}}
              files={localRestrictedImageList}
              viewMode={"icon"}
              onFileSelected={(fileId) => {
                defaultImageFromMediaIdRef.current = fileId;
              }}
              smallIcon={false}
              canDelete={false}
              hideHeaderMenu={true}
            />
          </>
        ),
        onSave: async () => {
          try {
            const fileId = defaultImageFromMediaIdRef.current;
            if (!fileId) return;
            const img = await FileService.getFile(fileId);
            setDisplayedImage(img);
            setFileId(fileId);
            return true;
          } catch (ex) {
            addToast(i18n.t("Generic.ServerError"), "BACKENDERROR", "ERROR", true);
            return false;
          }
        },
        onClose: () => {},
      });
    }
  };

  const handleDropdownChange = (e) => {
    const value = e.target.value;
    setSelectedOption(value);
    switch (value) {
      case "Aucune":
        setFileId(null);
        setDisplayedImage(null);
        break;
      case "Image du cheval":
        setDisplayedImage(horseThumbnail);
        setFileId(horseThumbnailfileId);
        break;
      case "Image du client":
        setDisplayedImage(clientThumbnail);
        setFileId(clientThumbnailFileId);
        break;

      case "Image du service":
        setDisplayedImage(serviceThumbnail);
        setFileId(serviceThumbnailFileId);
        break;
      case "Importer une image":
        setDisplayedImage(null);
        handleDefaultImageButtonClick();
        break;
      default:
        setDisplayedImage("");
        break;
    }
  };

  return (
    <>
      <FileUploaderModal
        showMultiImageTab={false}
        ref={fileUploadModal}
        callback={(thumbnail, fileId) => {
          setDisplayedImage(thumbnail);
          setFileId(fileId);
          fileUploadModal.current.close();
        }}
        allowMultipleFiles={false}
      />
      <div className={styles.container}>
        <div style={{ paddingBottom: "20px" }}>
          <label>{label}</label>
        </div>
        <select value={selectedOption} onChange={handleDropdownChange}>
          <option value="Aucune image">{i18n.t("Generic.DefaultImageOptions.None")}</option>
          {horseThumbnail && !localRestrictedImageList && (
            <option value="Image du cheval">{i18n.t("Generic.DefaultImageOptions.FromHorse")}</option>
          )}
          {clientThumbnail && !localRestrictedImageList && (
            <option value="Image du client">{i18n.t("Generic.DefaultImageOptions.FromClient")}</option>
          )}
          {serviceThumbnail && !localRestrictedImageList && (
            <option value="Image du service">{i18n.t("Generic.DefaultImageOptions.FromService")}</option>
          )}
          <option value="Importer une image">{i18n.t("Generic.DefaultImageOptions.Import")}</option>
        </select>
        <div className={styles.imgPreviewContainer}>
          {displayedImage && (
            <img className={styles.imgPreview} src={displayedImage} alt={i18n.t("PictureUploadField.ImgAltPreview")} />
          )}
        </div>
        {selectedOption === "Importer une image" && (
          <button type="button" onClick={handleDefaultImageButtonClick}>
            {i18n.t("PictureUploadField.LoadAnImage")}
          </button>
        )}
      </div>
    </>
  );
});

export default PictureUploadField;
